enum IOriginFinancialManagement {
    SALES_REVENUE = "1",
    SALES_DEDUCTION = "2",
    VARIABLE_COSTS = "3",
    VARIABLE_EXPENSES = "4",
    OPERATIONAL_EXPENSES = "5",
    OTHER_EXPENSES = "6"
}

export enum ITypeFinancialManagement {
    SUBSIDIARY = "2",
    SALES_CHANNEL = "3",
    PRODUCT_LINE = "4",
    VARIABLE_EXPENSES = "5",
    SALES_DEDUCTION = "6",
    CENTER_COST = "7",
    ACCOUNT = "8",
    OTHER_ACCOUNTS = "9",
    VARIABLE_COSTS = "10"
}

export const getTitleBudgetTypes = (type: ITypeFinancialManagement, translate: (text: string, objKeys?: object | undefined) => string) => {
	const titles = {
		[ITypeFinancialManagement.SUBSIDIARY]: "Unidade/Filial",
		[ITypeFinancialManagement.SALES_CHANNEL]: "Canal de venda",
		[ITypeFinancialManagement.PRODUCT_LINE]: "Produto/serviço",
		[ITypeFinancialManagement.VARIABLE_EXPENSES]: "Despesas variáveis",
		[ITypeFinancialManagement.SALES_DEDUCTION]: "Dedução de vendas",
		[ITypeFinancialManagement.CENTER_COST]: "Centro de custo",
		[ITypeFinancialManagement.ACCOUNT]: "Conta",
		[ITypeFinancialManagement.OTHER_ACCOUNTS]: "Outras contas",
		[ITypeFinancialManagement.VARIABLE_COSTS]: "Custos variáveis"
	};
	return translate(titles[type]);
}; 

export interface IOftba001{
	ofa001Id: number;
	ofa001Nome: string;
    ofa001Dtinicio: Date;
    ofa001Dtfim: Date;
	ofa001Dtplanejado: Date;
    ofa001Dtrealizado: Date;
	ofa001Template: "S" | "N";
	ofa001Vlrcorpatu:  "S" | "N";
	ofa001Rascunho:  "S" | "N";
    ofa001Mesinicio: number;
    permission: string;
}

export interface IOftba002{
	ofa002Id: number;
    ofa002Ofa001Id: number;
	ofa002Descricao: string;
    ofa002Codigo: number;
    ofa002Codinteg: string;
	ofa002Implucro: number;
}

export default IOriginFinancialManagement;
